import type { User } from '~/types/user'
import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { OAuthEndpoints } from '~/api/endpoints/oauth-endpoints'

export interface LoginCredentials {
  email: string
  password: string
}

export interface LoginResponse {
  token: string
  refreshToken: string
  expiresIn: number
  user: User
}

export interface AuthService {
  getCurrentUser: () => Promise<User>
  // login: (credentials: LoginCredentials) => Promise<LoginResponse>
  // logout: () => Promise<void>
  // refreshToken: (refreshToken: string) => Promise<{ token: string; expiresIn: number }>
}

interface GetUserApiResponse {
  status: string
  data: User
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): AuthService => {
  return {
    getCurrentUser: async () => {
      const { url, method, headers, body } = registry.createRequest(OAuthEndpoints.USER_INTROSPECT)
      const { data: user } = await client<GetUserApiResponse>(url, { method, headers, body })
      return user
    }

    // login: async (credentials: LoginCredentials) => {
    //   const { url, method, headers, body } = registry.createRequest(OAuthEndpoints.AUTH_LOGIN, {}, credentials)
    //   return await client<LoginResponse>(url, { method, headers, body })
    // },
    // logout: async () => {
    //   const { url, method, headers, body } = registry.createRequest(OAuthEndpoints.AUTH_LOGOUT)
    //   return await client<void>(url, { method, headers, body })
    // },
    // refreshToken: async (refreshToken: string) => {
    //   const { url, method, headers, body } = registry.createRequest(OAuthEndpoints.AUTH_REFRESH_TOKEN, {}, { refreshToken })
    //   return await client<{ token: string; expiresIn: number }>(url, { method, headers, body })
    // }
  }
}
